import React, { useState, useEffect, useCallback } from "react";
import SessionExpired from "../../pages/guest/pages/session-expired";
import Cookie from "js-cookie";

function PrivateLayout({ children }) {
  const [expirePreview, setExpirePreview] = useState(false);

  const logout = useCallback(() => {
    // Clear all cookies
    localStorage.removeItem("expirationTimestamp");
    Object.keys(Cookie.get()).forEach((cookieName) => {
      Cookie.remove(cookieName);
    });
    setExpirePreview(true);
  }, []);

  useEffect(() => {
    let timer;
    const SESSION_TIMEOUT = 2700000; // 45 minutes in milliseconds

    const resetTimer = () => {
      clearTimeout(timer);
      // Update the expiration timestamp in localStorage whenever activity happens
      const expirationTimestamp = Date.now() + SESSION_TIMEOUT;
      localStorage.setItem("expirationTimestamp", expirationTimestamp.toString());
      
      // Start a new timer for 45 minutes
      timer = setTimeout(() => {
        logout();
      }, SESSION_TIMEOUT);
    };

    const checkExpiration = () => {
      // Check if the user has been inactive for 45 minutes
      const expirationTimestamp = localStorage.getItem("expirationTimestamp");
      if (
        expirationTimestamp &&
        Date.now() > parseInt(expirationTimestamp, 10)
      ) {
        logout();
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkExpiration();
        // If the session hasn't expired yet, reset the timer when tab becomes visible
        if (!expirePreview) {
          resetTimer();
        }
      }
    };

    // Attach event listeners for user activity
    const events = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Attach visibility change listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Check expiration on component mount
    checkExpiration();
  
    // Initialize the timer
    resetTimer();

    // Cleanup on component unmount
    return () => {
      clearTimeout(timer);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [logout, expirePreview]);

  return (
    <div className="private-wrapper">
      {expirePreview ? <SessionExpired /> : children}
    </div>
  );
}

export default PrivateLayout;
